import React from "react";
import { X } from "lucide-react";
import {
  LinkToStacked,
  PageIndexProvider,
  useStackedPage,
} from "../react-stacked-pages-hook";
import { Box, Flex, Link, Text } from "theme-ui";
import { colors } from "../../styles/theme";
import "./note-wrapper.css";

function noteContainerClassName({ overlay, obstructed, highlighted } = {}) {
  return `note-container ${overlay ? "note-container-overlay" : ""} ${
    obstructed ? "note-container-obstructed" : ""
  } ${highlighted ? "note-container-highlighted" : ""}`;
}

const NoteHeader = ({ title, slug, i, closeNote }) => {
  const linkStyle = {
    fontSize: "1rem !important",
    cursor: "pointer",
    textDecoration: "none",
    color: colors.primaryMain,
    "&:hover": {
      textDecoration: "underline",
    },
  };
  return (
		<Flex
			dir="row"
			sx={{
				width: "100%",
				px: 2,
				mb: 2,
				border: "0px solid red",
				justifyContent: "space-between",
			}}
		>
			{i == 0 && slug !== "/hr-garden/" ? (
				<Text>🏠{" "}<Link sx={linkStyle} href={"/hr-garden/"}>Home</Link></Text>
			) : (
				<Box />
			)}
			{i > 0 ? (
				<Flex sx={{ alignItems: "center" }}>
					<X size={20} color={colors.primaryMain}/>
					<Link sx={linkStyle} onClick={closeNote}>Close</Link>
				</Flex>
			) : (
				<Box />
			)}
		</Flex>
	);
};

const NoteWrapper = ({ children, slug, title }) => {
  const [, state, i, , , closeStackedPage] = useStackedPage();

  const closeNote = () => {
    closeStackedPage(i);
  };

  return (
    <div
      className={noteContainerClassName(state)}
      style={{ left: 40 * (i || 0), right: -585 }}
    >
      <NoteHeader title={title} slug={slug} i={i} closeNote={closeNote} />
      <div className="note-content">{children}</div>
      <LinkToStacked to={slug} className="obstructed-label">
        {title}
      </LinkToStacked>
    </div>
  );
};

const ContextProvider = ({ i, ...rest }) => (
  <PageIndexProvider value={i}>
    <NoteWrapper {...rest} />
  </PageIndexProvider>
);

export default ContextProvider;
